import React, { useContext, useRef, useEffect, useState } from 'react'
import { Option, none, some, fold, isSome } from 'fp-ts/lib/Option';
import { pipe } from 'fp-ts/lib/pipeable';
import { exclamationCircle } from '../CalculatorTool/Icons';
import { CalculatorStepsContext } from '../Store/CalculatorStepsContext';

interface Props {
    id: string;
    messagesByIssue: Map<string, string>;
}

export const ValidationMessage = (props: Props) => {
    const store = useContext(CalculatorStepsContext);
    const issues = Array.from(props.messagesByIssue.keys());

    const alertFocus = useRef<HTMLParagraphElement>(null)
    const validation = store.steps.validation;

    const [showInvalid, setShowInvalid] = useState<boolean>(false);


    useEffect(() => {
        if (validation.hasIssueIn(issues)) {
            if (!showInvalid) {
                if (alertFocus.current !== null) {
                    alertFocus.current.focus();
                }
                setShowInvalid(true);
            }
        } else {
            setShowInvalid(false);
        }

    }, [validation]);

    function getMessageFromValidationFailure(): Option<string> {
        for (const issue of props.messagesByIssue.keys()) {
            if (store.steps.validation.hasIssue(issue)) {
                const msg = props.messagesByIssue.get(issue);
                if (msg) {
                    return some(msg);
                } else {
                    return none;
                }
            }
        }
        return none;
    }

    const messageOpt: Option<string> = (validation.isSuccess())
        ? none
        : getMessageFromValidationFailure();
    const messageElement = pipe(messageOpt,
        fold(
            () => null,
            (validationFailedMessage) => (
                <p ref={alertFocus} tabIndex={0} className="validation-failed">{exclamationCircle} <span className="sr-only">This step has a validation error:</span> <span dangerouslySetInnerHTML={{ __html: validationFailedMessage }}></span></p>
            )
        ));
    return (
        isSome(messageOpt)
            ? <div className="validation-message" id={props.id} role="alert" data-testid='fx-glwb-c-validation-message'>
                {messageElement}
            </div>
            : null
    )
}
